import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const ButtonWithProgress = ({ options }: { options: Options }) => {
  const {
    onClick,
    showProgressAnimation = false,
    buttonTypeClass = 'button-primary',
    cta = 'button',
    type = 'button',
    name,
    wrapperClasses = '',
    buttonClasses = '',
    disabled = false,
    // if stroke dash animation is lost under heave load, set to true https://github.com/mui/material-ui/issues/10327
    disableShrink = false,
    testId = '',
    tabIndex,
  } = options;
  return (
    <div className={`${wrapperClasses}`}>
      <button
        type={type}
        tabIndex={tabIndex}
        onClick={onClick}
        disabled={disabled}
        name={name}
        className={`${buttonTypeClass} ${buttonClasses} button-progress`}
        data-testid={testId}
      >
        {showProgressAnimation && (
          <CircularProgress disableShrink={disableShrink} size={20} thickness={2.6} color="inherit" />
        )}
        {cta}
      </button>
    </div>
  );
};

export default ButtonWithProgress;

interface Options {
  onClick?: () => void;
  showProgressAnimation: boolean;
  cta: string | JSX.Element;
  buttonTypeClass?: buttonYogaUIClasses;
  wrapperClasses?: string;
  buttonClasses?: string;
  type?: 'button' | 'submit' | 'reset';
  name?: string;
  disabled?: boolean;
  padding?: string;
  disableShrink?: boolean;
  testId?: string;
  tabIndex?: number;
}

type buttonYogaUIClasses =
  | 'button-primary'
  | 'button-ghost'
  | 'button-invert'
  | 'button-primary-md'
  | 'button-ghost-md'
  | 'button-invert-md';
